import styled from 'styled-components';
import { Button } from '../../../components/utils/Button/Button';
import { Text15Bold, Text16Light, Text20Bold } from '../../../components/utils/Text/Text.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.4rem;
  padding: 2.4rem 0;
  width: 100%;

  @media only screen and (max-width: 760px) {
    padding: 1.6rem 1.2rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 42rem;
  margin-inline: auto;

  @media only screen and (max-width: 760px) {
    width: 100%;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 3.4rem;
  width: 24rem;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
    width: 100%;
  }
`;

export const Title = styled(Text20Bold)`
  letter-spacing: -0.408px;
`;

export const Subtitle = styled(Text16Light)`
  margin-top: 1.8rem;
  margin-bottom: 2rem;
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 1.2rem;
`;

export const LinkText = styled(Text15Bold)`
  text-decoration-line: underline;
  color: #1672ba;
  cursor: pointer;
`;

export const InvitationCodeWrapper = styled.div`
  border-radius: 15px;
  background: linear-gradient(93deg, #d8eaf9 1.58%, #badaf7 100%);
  padding: 1.6rem 1.2rem 0 1.2rem;
  width: 100%;
  margin-bottom: 2.1rem;
`;
